import { FormCheckBox, useFormContext } from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { TAllowedActionForm } from "./allowedActionSchema";
import { useWatch } from "react-hook-form";
import { ConsultationReceivedRule } from "./ConsultationReceivedRule";
import { ExamsReceivedRule } from "./ExamsReceivedRule";
import { ReturnReceivedRule } from "./ReturnReceivedRule";
import { FeaturedReceivedRule } from "./FeaturedReceivedRule";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutomationReceivedRuleAllowedAction.";

export const AllowedActionFields = memo(() => {
  const { t } = useTranslation();

  const { setValue, control } = useFormContext<TAllowedActionForm>();

  const reschedule = useWatch({
    control,
    name: "reschedule",
  });

  return (
    <>
      <Grid item xs={12} sm={12}>
        <FormCheckBox
          name="newSchedule"
          label={t(translationPath + "new_schedule") || "New Schedule"}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <FormCheckBox
          name="confirm"
          label={t(translationPath + "confirm_field") || "Confirm"}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <FormCheckBox
          name="cancel"
          label={t(translationPath + "cancel") || "Cancel"}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <FormCheckBox
          name="checkIn"
          label={t(translationPath + "check_in") || "Check-in"}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <FormCheckBox
          name="reschedule"
          label={t(translationPath + "reschedule") || "Reschedule"}
          onChangeCapture={() => {
            setValue("consultationTicketAutomationReceivedRule", null);
            setValue("examTicketAutomationReceivedRule", null);
            setValue("featuredTicketAutomationReceivedRule", null);
            setValue("returnTicketAutomationReceivedRule", null);
          }}
        />
      </Grid>

      {reschedule && (
        <>
          <Grid item xs={12}>
            <Typography variant="body2">
              {t(translationPath + "reschedule_fields_caption")}
            </Typography>
          </Grid>

          <ConsultationReceivedRule />

          <ExamsReceivedRule />

          <ReturnReceivedRule />

          <FeaturedReceivedRule />
        </>
      )}
    </>
  );
});
